import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckCircle, Clock, Plus, Minus, ShoppingCart } from 'lucide-react';
import api from '../lib/api';
import './Packages.css';

export default function Packages() {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadPackages();
  }, []);

  const loadPackages = async () => {
    try {
      const data = await api.getPackages();
      setPackages(data);
    } catch (error) {
      console.error('Error loading packages:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="packages-page">
      <section className="packages-hero">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <span className="section-subtitle">Event Packages</span>
            <h1 className="page-title">All-Inclusive Packages</h1>
            <p className="page-description">
              Save more with our curated event packages. Everything you need for an unforgettable experience.
            </p>
          </motion.div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          {loading ? (
            <div className="loading">
              <div className="spinner" />
            </div>
          ) : (
            <div className="packages-grid">
              {packages.map((pkg, index) => (
                <motion.div
                  key={pkg.id}
                  className={`package-card ${pkg.popular ? 'popular' : ''}`}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  viewport={{ once: true }}
                >
                  {pkg.popular && <span className="package-badge">Most Popular</span>}
                  <h3 className="package-name">{pkg.name}</h3>
                  <div className="package-price">
                    <span className="price-amount">${pkg.price}</span>
                  </div>
                  <div className="package-meta">
                    <span><Clock size={16} /> {pkg.duration}</span>
                  </div>
                  <p className="package-description">{pkg.description}</p>
                  
                  <div className="package-includes">
                    <h4>What's Included:</h4>
                    <ul className="package-features">
                      {pkg.features?.map((feature, i) => (
                        <li key={i}>
                          <CheckCircle size={16} className="text-gold" />
                          <span>{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <Link to="/book" className="btn btn-primary w-full">
                    Book This Package
                  </Link>
                </motion.div>
              ))}
            </div>
          )}

          <div className="custom-package-cta">
            <h3>Need Something Custom?</h3>
            <p>Build your own package with our individual rentals</p>
            <Link to="/rentals" className="btn btn-secondary">
              Browse Rentals
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
